export default "__VITE_ASSET__C1MDZi8T__"